<script lang="ts">
  import type { VideoAdTopProps } from '$src/js/_types/VideoAd';
  import { onMount } from 'svelte';
  import BaseModule from '$src/js/app/base/BaseModule';

  let { videoAdTopData, onSendPageView }: VideoAdTopProps = $props();

  let containerElement: HTMLElement | null = $state(null);
  let hasBeenViewed = $state(false);

  onMount(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasBeenViewed) {
            hasBeenViewed = true;

            onSendPageView();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 },
    );

    observer.observe(containerElement!);

    return () => {
      observer.disconnect();
    };
  });
</script>

<div bind:this={containerElement} class="relative aspect-video w-full">
  <video class="h-full w-full" muted autoplay playsinline loop>
    <source src={videoAdTopData.video.url} type="video/mp4" />
  </video>

  <a
    href={videoAdTopData.cta.url}
    target="_blank"
    class="group bg-surface-neutral-def-base/20 hover:bg-surface-neutral-def-base/60 transition-200 relative flex items-center gap-4 px-4 py-3 transition-all"
  >
    <img class="h-12 w-12 object-cover" alt="Ad" src={videoAdTopData.cta.image} />

    <div class="flex flex-col gap-2">
      <span class="text-11asrem leading-[130%] italic">
        {BaseModule.getInstance().i18n.translate('advertisement')}
      </span>

      <h2 class="text-15asrem leading-[130%] font-semibold">{videoAdTopData.cta.title}</h2>
      <p class="text-11asrem leading-[130%] group-hover:underline">{videoAdTopData.cta.label} ></p>
    </div>
  </a>
</div>
